var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h1',{staticClass:"text-center display-2 font-weight mt-8 mb-6"},[_vm._v("Le mie consegne")]),(_vm.deliveries)?_c('div',_vm._l((_vm.deliveries),function(d){return _c('delivery-list-item',{key:d.distSessionId,attrs:{"delivery":d}})}),1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }